import React, { Component } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';

import services from '@C/StaffManagement/_utils/data';
import { formatCurrency, TableGrid } from '@C/TableGrid';
import { PaymentMethodInfo, StaffList } from '@C/Utils';
import DropLoaderLarge from '@C/Utils/DropLoaderLarge';
import { authHeader } from '@H';
import { DateRangeFilter } from '@C/Utils';

const col = [
  {
    name: 'Date',
    key: 'time_stamp',
    sortable: true,
    type: 'date',
  },
  {
    name: 'Employee',
    key: 'employee',
    formatter(props) {
      return (
        <>
          {props.first_name} {props.last_name}
        </>
      );
    },
  },
  {
    name: 'Salary type',
    key: 'salary_type',
    formatter(props) {
      return <>{props.salary_mode}</>;
    },
  },
  {
    name: 'Salary amount',
    key: 'all',
    formatter(props) {
      return <>{formatCurrency(props.salary)}</>;
    },
  },
  {
    name: 'Advance taken',
    key: 'all',
    formatter(props) {
      return <>{formatCurrency(props.advance_taken)}</>;
    },
  },
  {
    name: 'Advance adjusted',
    key: 'all',
    formatter(props) {
      return <>{formatCurrency(props.settled_amount)}</>;
    },
  },
  {
    name: 'Incentives',
    key: 'all',
    formatter(props) {
      return <>{formatCurrency(props.other_incentives)}</>;
    },
  },
  {
    name: 'Bonus',
    key: 'all',
    formatter(props) {
      return <>{formatCurrency(props.bonus)}</>;
    },
  },
  {
    name: 'Deductions',
    key: 'all',
    formatter(props) {
      return <>{formatCurrency(props.deduction)}</>;
    },
  },
  {
    name: 'Salary paid',
    key: 'all',
    formatter(props) {
      return <>{formatCurrency(props.paid_amount)}</>;
    },
  },
  {
    name: 'Paid by',
    key: 'salary_given',
    formatter(props) {
      return (
        <>
          {props.first_name} {props.last_name}
        </>
      );
    },
  },
  {
    name: 'Payment mode',
    key: 'all',
    formatter(props) {
      return (
        <>
          <PaymentMethodInfo
            source={props.payment.source}
            method={props.payment.payment_method}
            bank={props.bank}
          />
        </>
      );
    },
  },
  {
    name: 'Notes',
    key: 'notes',
  },
];

const enabledActions = [
  {
    action: 'Delete',
    roles: ['Manager', 'Dealer'],
  },
];

export default class AdvanceList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      salaryList: [],
      showModal: false,
      selectedData: '',
      start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      month: dayjs().format('MMMM').toUpperCase(),
      year: dayjs().format('YYYY'),
      staff_id: '',
      given_by: '',
      offset: 1,
      count: 0,
      limit: 20,
      loading: true,
    };

    this.limitInput = React.createRef();
  }

  componentDidMount() {
    this.getSalaryList();
  }

  getSalaryList = () => {
    services
      .getSalaryList(this.state)
      .then((res) => {
        this.setState({
          salaryList: res.data.data.results,
          count: res.data.data.count,
          loading: false,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handlePagination = (e) => {
    this.setState({ offset: e, loading: true }, function () {
      this.getSalaryList();
    });
  };

  handleDateChange = (e) => {
    const { name, value } = e.target;
    if (name === 'start_date' && dayjs(value).isAfter(this.state.end_date)) {
      this.setState({ [name]: value, end_date: value });
    } else if (
      name === 'end_date' &&
      dayjs(value).isBefore(this.state.start_date)
    ) {
      this.setState({ [name]: value, start_date: value });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleStaffChange = (e) => {
    this.setState({ staff_id: e.value });
  };

  handleProviderChange = (e) => {
    this.setState({ given_by: e.value });
  };

  handleQuickSearch = (e) => {
    e.preventDefault();
    if (
      this.limitInput.current.value === '' ||
      this.limitInput.current.value === '0'
    ) {
      return;
    }
    this.setState(
      { limit: this.limitInput.current.value, offset: 1 },
      function () {
        this.getSalaryList();
      },
    );
  };

  resetFilter = () => {
    this.setState(
      {
        start_date: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
        month: dayjs().format('MMMM').toUpperCase(),
        year: dayjs().format('YYYY'),
        staff_id: '',
        given_by: '',
        offset: 1,
        count: 0,
        limit: 20,
        loading: false,
      },
      function () {
        //this.getSalaryList();
      },
    );
  };

  confirmDelete = (item) => {
    confirmAlert({
      title: 'Confirm transaction deletion',
      message: 'Are you sure',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.deleteItem(item),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  deleteItem = (item) => {
    const headers = authHeader(1);
    axios
      .delete(
        `${process.env.API_URL}/staff-management/bunk/salary/?uuid=${item.uuid}`,
        {
          headers,
        },
      )
      .then(() => {
        toast.success('Transaction deleted successfully');
        this.getSalaryList();
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, function () {
      this.getSalaryList();
    });
  };

  render() {
    const { salaryList } = this.state;

    return (
      <>
        <section className="widget full-width list-table">
          <header>
            <h3> Salary List</h3>
          </header>
          <main>
            <div className="table-filters">
              <div className="filter-wrapper">
                <div className="filter-group with-icon">
                  <label>
                    Results to display- {this.state.limit || 20} (Total:{' '}
                    {this.state.count})
                  </label>
                  <form onSubmit={this.handleQuickSearch}>
                    <input type="text" name="limit" ref={this.limitInput} />
                    <button
                      type="submit"
                      className="search-icon"
                      onClick={this.handleQuickSearch}
                    />
                  </form>
                </div>
                <div className="filter-group">
                  <label>Date range:</label>
                  <DateRangeFilter
                    value={[this.state.start_date, this.state.end_date]}
                    onChange={(dates) => {
                      this.setState({
                        start_date: dates[0],
                        end_date: dates[1],
                      });
                    }}
                    limit={6}
                  />
                </div>
                <div className="filter-group">
                  <label>Staff:</label>
                  <StaffList
                    value={this.state.staff_id}
                    onChange={this.handleStaffChange}
                  />
                </div>
                <div className="filter-group">
                  <label>Given by:</label>
                  <StaffList
                    value={this.state.given_by}
                    onChange={this.handleProviderChange}
                  />
                </div>

                <div className="filter-group reset-filter">
                  <button onClick={this.resetFilter}>Reset filters</button>
                </div>
                <div className="filter-group">
                  <button
                    className={`submit ${this.state.loading ? 'loading' : ''}`}
                    disabled={this.state.loading}
                    type="submit"
                    onClick={this.submitForm}
                  >
                    Apply filter
                  </button>
                </div>
              </div>
            </div>
            <div className="table-wrapper">
              {(() => {
                if (this.state.loading) {
                  return <DropLoaderLarge />;
                } else {
                  return (
                    <TableGrid
                      col={col}
                      row={salaryList}
                      limit={this.state.limit}
                      offset={this.state.offset}
                      count={this.state.count}
                      onEdit={this.props.onEdit}
                      onDelete={this.confirmDelete}
                      handlePagination={this.handlePagination}
                      enabledActions={enabledActions}
                    />
                  );
                }
              })()}
              <div className="mini-summary">
                <ul>
                  <li>
                    <span>Total salary amount: </span>
                    <span>
                      {new Intl.NumberFormat('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                      }).format(
                        salaryList.reduce(
                          (a, b) => a + (b['paid_amount'] || 0),
                          0,
                        ) || 0,
                      )}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </main>
        </section>
      </>
    );
  }
}
